import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { deleteOffering } from '../api/offerings';
import { notification } from 'antd';

export function useDeleteOffering() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteOffering(id),
    onSuccess: () => {
      notification.success({ message: 'Offering deleted successfully' });
      invalidateListResource(queryClient, 'offerings');
    },
    onError: () => {
      notification.error({ message: 'Failed to delete offering' });
    },
  });
}
